import { z } from 'zod';

export const UpdateCustomerRoleBodySchema = z.object({
  notes: z.string().trim().nullable().optional(),
  referredByOrganizationGroupId: z.uuid().nullable().optional(),
});

export type UpdateCustomerRoleBody = z.infer<typeof UpdateCustomerRoleBodySchema>;

export const UpdateCustomerRoleResponseSchema = z.object({
  customerRoleId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdateCustomerRoleResponse = z.infer<typeof UpdateCustomerRoleResponseSchema>;
